var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAtSign = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 6.66666V10.8333C13.3337 11.4964 13.5971 12.1323 14.0659 12.6011C14.5347 13.0699 15.1706 13.3333 15.8337 13.3333C16.4967 13.3333 17.1326 13.0699 17.6014 12.6011C18.0703 12.1323 18.3337 11.4964 18.3337 10.8333V9.99999C18.3336 8.11918 17.6972 6.29372 16.5281 4.82043C15.3589 3.34715 13.7258 2.31268 11.8942 1.88524C10.0626 1.4578 8.14028 1.66253 6.43979 2.46613C4.7393 3.26974 3.36066 4.62495 2.52805 6.31143C1.69543 7.9979 1.45781 9.91644 1.85381 11.7551C2.24981 13.5937 3.25615 15.2444 4.70919 16.4385C6.16224 17.6327 7.97653 18.3003 9.85706 18.3326C11.7376 18.365 13.5738 17.7602 15.067 16.6167M13.3337 9.99999C13.3337 11.8409 11.8413 13.3333 10.0003 13.3333C8.15939 13.3333 6.667 11.8409 6.667 9.99999C6.667 8.15904 8.15939 6.66666 10.0003 6.66666C11.8413 6.66666 13.3337 8.15904 13.3337 9.99999Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAtSign, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/at-sign.9b7e91c6.svg";
export { ForwardRef as ReactComponent };